import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Mousewheel } from "swiper/modules";
import MovieCard from "./MovieCard";
import ButtonViewAll from "./ButtonViewAll";
import NotFoundList from "./NotFoundList";
import i18n from "../../config/i18n"; // Import i18n

interface ListHorizontalProps {
  title: string;          // expected: "Phim hot"
  movies: any[];
  type: string;           // "lists"
  posttype: string;       // "movie"
  api: string;            // "/posts/lists/movie/"
  onClickViewMore?: () => void; // Optional function to handle view more action
}

const ListHorizontal: React.FC<ListHorizontalProps> = ({
  title,
  movies,
  api,
  type,
  posttype,
  onClickViewMore,
}) => {
  const navigate = useNavigate();
  if (!movies || movies.length === 0) {
    return null; // Return null if no movies are provided
  }
  return (
    <div className="list-horizontal w-full overflow-hidden px-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-white">{title}</h2>
        <div className="flex items-center">
          <button
            onClick={() => {
              if (onClickViewMore) {
                onClickViewMore();
              } else {
                navigate(`/${type}/${posttype}/lists`);
              }
            }}
            className="btn-link text-[12px] text-white"
          >
            Xem thêm
          </button>
          <div className="flex items-center justify-center w-6 h-6">
            <img src={"/assets/icons/right-icon.svg"} alt="Arrow" />
          </div>
        </div>
      </div>
      {movies.length > 0 ? (
        <Swiper
          spaceBetween={0}
          slidesPerView={"auto"}
          mousewheel={{ forceToAxis: true }}

          modules={[Mousewheel]}
          className="container-swiper"
        >
          {movies.map((item: any, idx: number) => (
            <SwiperSlide key={item.id || idx} style={{ width: "180px", marginRight:'16px',  overflow: "hidden" }}>
              <MovieCard 
                movie={item} 
                className="mr-4"
                size="small"
                onClick={() => {                  
                  // Force navigation and reload for movies in horizontal lists
                  const { lang } = item;
                  // Use i18n's default language if we're on the root path
                  const currentLang = window.location.hash.split('/')[1] || i18n.options.fallbackLng;
                  navigate(`/${currentLang}/${item.posttype || 'movie'}/${item.slug}`, { 
                    state: { item: item }
                  });
                  window.scrollTo(0, 0); // Ensure scroll to top
                }}
              />
            </SwiperSlide>
          ))}
          {/* ButtonViewAll ở cuối list */}
          {/* <SwiperSlide key="view-all" style={{   marginLeft: "16px", overflow: "hidden", height:'auto', display: 'flex', alignItems: 'stretch' }}>
            <ButtonViewAll
              onClick={() => {
                if (onClickViewMore) {
                  onClickViewMore();
                } else {
                  navigate(`/${type}/${posttype}/lists`);
                }
                window.scrollTo(0, 0);
              }}
            />
          </SwiperSlide> */}
        </Swiper>
      ) : (
       <NotFoundList
            title="Không có danh sách nào"
            description="Danh sách này hiện không có nội dung."
        />
      )}
    </div>
  );
};

export default ListHorizontal;
